import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BoardMedium_URL } from "../../config";

// Async Thunks
// export const fetchChapters = createAsyncThunk(
//   "chapters/fetch",
//   async (boardId, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(
//         `${BoardMedium_URL}/chapters-board-wise?board_id=${boardId}`,
//       );
//       return response.data.data || [];
//     } catch (error) {
//       console.error("Error fetching chapters:", error);
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   },
// );
export const fetchChapters = createAsyncThunk(
  "chapters/fetch",
  async (
    { board_id, medium_id, class_id, subject_id, page = 1, limit = 10 },
    { rejectWithValue },
  ) => {
    try {
      const response = await axios.get(
        `${BoardMedium_URL}/chapters-board-wise`,
        {
          params: {
            board_id,
            medium_id,
            subject_id,
            class_id,
            page,
            limit,
          },
        },
      );

      console.log("40", response.data.data);

      return {
        data: response.data.data || [],
        pagination: response.data.pagination || {},
      };
    } catch (error) {
      console.error("Error fetching chapters:", error);
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const addChapter = createAsyncThunk(
  "chapters/add",
  async (chapterData) => {
    const response = await axios.post(
      `${BoardMedium_URL}/create-chapter`,
      chapterData,
    );
    return response.data;
  },
);

export const deleteChapter = createAsyncThunk("chapters/delete", async (id, { rejectWithValue }) => {
  try {
    await axios.delete(`${BoardMedium_URL}/delete-chapter/${id}`);
    return id;
  } catch (err) {
    return rejectWithValue(err.response?.data?.message || "Failed to delete chapter");
  }
});

// Added this thunk using your BoardMedium_URL
export const updateChapter = createAsyncThunk(
  "chapters/update",
  async ({ id, name }) => {
    await axios.put(`${BoardMedium_URL}/update-chapter/${id}`, { name });
    return { id, name };
  },
);
export const linkChapterSub = createAsyncThunk(
  "subject/linkChapterSub",
  async (payload) => {
    const res = await axios.post(
      `${BoardMedium_URL}/link-chapters-to-subject`,
      payload,
    );
    return res.data;
  },
);
export const fetchLinkedChapters = createAsyncThunk(
  "subject/fetchLinkedChapters",
  async ({ board_id, subject_id }) => {
    const res = await axios.get(
      `${BoardMedium_URL}/linked-chapters/${board_id}/${subject_id}`,
    );
    return res.data.data; // array of chapter ids
  },
);

// Fetch classes by board and medium
export const fetchClassesByBoardMedium = createAsyncThunk(
  "chapters/fetchClasses",
  async ({ board_id, medium_id }, { rejectWithValue }) => {
    try {
      let url = `${BoardMedium_URL}/classes-by-bm3?board_id=${board_id}`;
      if (medium_id) {
        url += `&medium_id=${medium_id}`;
      }
      const response = await axios.get(url);
      return response.data.data || [];
    } catch (error) {
      console.error("Error fetching classes:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Fetch linked subjects by class
export const fetchLinkedSubjects = createAsyncThunk(
  "chapters/fetchSubjects",
  async (class_id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BoardMedium_URL}/linked-subjects2/${class_id}`,
      );
      return response.data.data || [];
    } catch (error) {
      console.error("Error fetching subjects:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const chapterSlice = createSlice({
  name: "chapters",
  initialState: {
    items: [],
    loading: false,
    error: null,
    pagination: {},
    // Add chapter form state
    classes: [],
    subjects: [],
    selectedMedium: null,
    selectedClass: null,
    selectedSubject: null,
    chapterName: "",
    classesLoading: false,
    subjectsLoading: false,
  },
  reducers: {
    setSelectedMedium: (state, action) => {
      state.selectedMedium = action.payload;
      state.selectedClass = null;
      state.selectedSubject = null;
      state.classes = [];
      state.subjects = [];
      state.chapterName = "";
    },
    setSelectedClass: (state, action) => {
      state.selectedClass = action.payload;
      state.selectedSubject = null;
      state.subjects = [];
      state.chapterName = "";
    },
    setSelectedSubject: (state, action) => {
      console.log("srinu", action.payload);
      state.selectedSubject = action.payload;
      state.chapterName = "";
    },
    setChapterName: (state, action) => {
      state.chapterName = action.payload;
    },
    resetAddChapterForm: (state) => {
      state.selectedMedium = null;
      state.selectedClass = null;
      state.selectedSubject = null;
      state.chapterName = "";
      state.classes = [];
      state.subjects = [];
    },
    resetChaptersList: (state) => {
      state.items = [];
      state.pagination = {};
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch chapters
      .addCase(fetchChapters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchChapters.fulfilled, (state, action) => {
        state.items = action.payload.data || [];
        state.pagination = action.payload.pagination;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchChapters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch chapters";
      })
      // Add chapter
      .addCase(addChapter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addChapter.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(addChapter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to add chapter";
      })
      // Update chapter
      .addCase(updateChapter.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateChapter.fulfilled, (state, action) => {
        const index = state.items.findIndex(
          (item) => item.id === action.payload.id,
        );
        if (index !== -1) {
          state.items[index].name = action.payload.name;
        }
        state.loading = false;
      })
      .addCase(updateChapter.rejected, (state) => {
        state.loading = false;
      })
      // Delete chapter
      .addCase(deleteChapter.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteChapter.fulfilled, (state, action) => {
        // state.items = state.items.filter((item) => item.id !== action.payload);
        state.loading = false;
      })
      .addCase(deleteChapter.rejected, (state) => {
        state.loading = false;
      })
      // Link chapter to subject
      .addCase(linkChapterSub.pending, (state) => {
        state.loading = true;
      })
      .addCase(linkChapterSub.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(linkChapterSub.rejected, (state) => {
        state.loading = false;
      })
      // Fetch linked chapters
      .addCase(fetchLinkedChapters.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLinkedChapters.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchLinkedChapters.rejected, (state) => {
        state.loading = false;
      })
      // Fetch classes by board and medium
      .addCase(fetchClassesByBoardMedium.pending, (state) => {
        state.classesLoading = true;
        state.error = null;
      })
      .addCase(fetchClassesByBoardMedium.fulfilled, (state, action) => {
        state.classes = action.payload || [];
        state.classesLoading = false;
        state.error = null;
      })
      .addCase(fetchClassesByBoardMedium.rejected, (state, action) => {
        state.classesLoading = false;
        state.error = action.payload || "Failed to fetch classes";
      })
      // Fetch linked subjects by class
      .addCase(fetchLinkedSubjects.pending, (state) => {
        state.subjectsLoading = true;
        state.error = null;
      })
      .addCase(fetchLinkedSubjects.fulfilled, (state, action) => {
        state.subjects = action.payload || [];
        state.subjectsLoading = false;
        state.error = null;
      })
      .addCase(fetchLinkedSubjects.rejected, (state, action) => {
        state.subjectsLoading = false;
        state.error = action.payload || "Failed to fetch subjects";
      });
  },
});

export const {
  setSelectedMedium,
  setSelectedClass,
  setSelectedSubject,
  setChapterName,
  resetAddChapterForm,
  resetChaptersList,
} = chapterSlice.actions;

export default chapterSlice.reducer;
